import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getDemoLastStep } from "@/services/sessionStore";

/**
 * Floating banner that lets the user return to the running demo
 * after they navigated to a real feature page from inside the demo.
 */
export default function DemoReturnBanner() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [active, setActive] = useState(false);
  const [step, setStep] = useState<string>("about");

  useEffect(() => {
    try {
      const dismissed = sessionStorage.getItem("demo.returnBanner.dismissed") === "1";
      const lastStep = getDemoLastStep();
      setActive(!dismissed && !!lastStep);
      if (lastStep) setStep(lastStep);
    } catch {
      setActive(false);
    }
  }, [location.pathname]);

  if (!active || location.pathname.startsWith("/demo")) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 animate-fade-up">
      <div className="flex items-center gap-3 rounded-full bg-gradient-to-r from-cta-from to-cta-to text-white pl-4 pr-2 py-2 shadow-2xl">
        <Sparkles className="w-4 h-4 shrink-0" />
        <button
          type="button"
          onClick={() => navigate(`/demo-v3/${step}`)}
          className="text-sm font-semibold hover:underline"
        >
          {t("demoReturnBanner.backSimple", "← Reprendre la démo")}
        </button>
        <button
          type="button"
          aria-label={t("demoReturnBanner.close", "Close")}
          onClick={() => {
            try {
              sessionStorage.setItem("demo.returnBanner.dismissed", "1");
            } catch {
              /* ignore */
            }
            setActive(false);
          }}
          className="w-7 h-7 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}